import { gql } from "@apollo/client";

const GET_COMPANY_DOCUMENTS = gql`
  query Company($companyId: ID!) {
    company(id: $companyId) {
      companyInfo {
        documents {
          title
          url
        }
      }
    }
  }
`;
const GET_COMPANY_DITL_INFO = gql`
  query Company($companyId: ID!) {
    company(id: $companyId) {
      companyInfo {
        address {
          city
          number
          county
          street
          venueName
        }
        legalRepresentativeEmail
        companyName
        uniqueRegistrationCode
        tradeRegistryNumber
        postalCode
        legalRepresentativeFirstName
        legalRepresentativeLastName
      }
    }
  }
`;

const GET_COMPANY_STATUS = gql(`
query Company($companyId: ID!) {
  company(id: $companyId) {
    approval
  }
}
`);

const SEARCH_CUSTOMERS= gql(`
query SearchCustomers($bookingModuleId: ID!, $phone: String!) {
  searchCustomers(bookingModuleId: $bookingModuleId, phone: $phone) {
    id
    firstName
    lastName
    email
    phone
    companyClientTags {
      id
      name
    }
  }
}
`);

const GET_COMPANY_BT_CREDENTIALS_STATUS = gql`
  query GetCompanyBtCredentialsStatus($companyId: ID!) {
    companyBtCredentialsStatus(companyId: $companyId) {
      configured
      enabled
      updatedAt
    }
  }
`;

export { GET_COMPANY_DOCUMENTS, GET_COMPANY_DITL_INFO, GET_COMPANY_STATUS, SEARCH_CUSTOMERS, GET_COMPANY_BT_CREDENTIALS_STATUS };
